import { Image } from '..';
import { CSSProperties, useCallback } from 'react';
import styled, { css } from 'styled-components';

const ImageContainer = styled.button<{ isClickable: boolean }>`
  border: ${({ theme }) => theme.vars.newColor.lightGS1} 1px solid;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  padding: 0;
  margin: 0;
  overflow: hidden;
  ${({ isClickable }) => {
    return isClickable
      ? css`
          cursor: pointer;
        `
      : css`
          cursor: default;
        `;
  }}
`;

const resolveDimensionType = (dimension: number | string) => {
  if (typeof dimension === 'number') {
    return `${dimension}px`;
  }

  return dimension;
};

type Dimensions = Pick<CSSProperties, 'height' | 'width'>;
const Container = styled.div<Dimensions>`
  height: ${({ height }) => resolveDimensionType(height)};
  width: ${({ width }) => resolveDimensionType(width)};
`;

export interface ImageAreaProps extends Dimensions, IntrinsicProps {
  src: string;
  fallback: string;
  thumbnailDimensions?: Dimensions;
  isClickable?: boolean;
}

export function ImageArea({
  src,
  fallback,
  width,
  height,
  thumbnailDimensions = {},
  isClickable,
  ...props
}: ImageAreaProps) {
  const getPlaceholderImage = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e: any) => {
      if (e.target.src !== fallback) {
        e.target.src = fallback;
      }
    },
    [fallback],
  );

  return (
    <Container width={width} height={height} {...props}>
      <ImageContainer className="thumbnail-container" isClickable={isClickable}>
        <Image src={src} style={{ ...thumbnailDimensions }} onError={getPlaceholderImage} />
      </ImageContainer>
    </Container>
  );
}

ImageArea.defaultProps = {
  width: 'auto',
  height: 120,
};
